export const SELECT_TRIGGER_STATE_CLASSES =
  'border-gray-600 hover:border-gray-500 hover:bg-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-gray-1000'
